import { api, callAPi } from "./api";

const base = (tributeId) => `/tributes/${tributeId}/comments`;

export const getComments = (tributeId) =>
  api.get(`${base(tributeId)}`).then((res) => res.data);

export const sendOtp = (tributeId, { name, email, commentText }) =>
  api
    .post(`${base(tributeId)}/send-otp`, { name, email, commentText })
    .then((res) => res.data);

export const verifyOtp = (tributeId, { name, email, commentText, otp }) =>
  api
    .post(`${base(tributeId)}/verify`, { name, email, commentText, otp })
    .then((res) => res.data);

export const getCommentsAdmin = (tributeId) =>
  callAPi.get(`/admin/tributes/${tributeId}/comments`).then((res) => res.data);

export const deleteCommentAdmin = (tributeId, commentId) =>
  callAPi.delete(`/admin/tributes/${tributeId}/comments/${commentId}`);
